import styled from 'styled-components';
import { screenXsMax, screenSmMin, spacer24, spacer8, gray60 } from '@spotify-internal/encore-foundation';
export default styled.footer.withConfig({
  displayName: "Container",
  componentId: "yimjyf-0"
})(["display:flex;border-top:1px solid ", ";@media (max-width:", "){padding-bottom:", ";padding-top:", ";}@media (min-width:", "){padding:", " ", ";}>:last-child{display:flex;align-items:flex-end;justify-content:flex-end;flex:1;}"], gray60, screenXsMax, spacer24, spacer24, screenSmMin, spacer24, spacer8);